/* eslint-disable no-useless-escape */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */

import Command from '@/models/CommandModel';

// Api for conversation between widget (at another site) and chat
export default (function () {
	let interval_id = null as any;
	let last_hash = null as any;
	let attached_callback = null as any;

	return {
		postMessage(message: Command) {
			let parentUrl = decodeURIComponent(
				window.location.hash.toString().replace(/^#/, '')
			);

			if (message.name === 'bbWidgetMessage') {
				parentUrl = '*';
			}

			if (window['postMessage']) {
				parent['postMessage'](message, parentUrl);
			}
		},
		subscribeOnMessages(callback: Function, source_origin: any) {
			// browser supports window.postMessage
			if (window['postMessage']) {
				// bind the callback to the actual event associated with window.postMessage
				if (callback) {
					attached_callback = function (e: any) {
						if (
							(typeof source_origin === 'string' && e.origin !== source_origin) ||
							(Object.prototype.toString.call(source_origin) === '[object Function]' &&
								source_origin(e.origin) === !1)
						) {
							return !1;
						}
						callback(e);
					};
				}
				if (window['addEventListener']) {
					window[callback ? 'addEventListener' : 'removeEventListener'](
						'message',
						attached_callback,
						!1
					);
				} else {
					window[callback ? 'attachEvent' : 'detachEvent'](
						'onmessage',
						attached_callback
					);
				}
			} else {
				// a polling loop is started & callback is called whenever the location.hash changes
				interval_id && clearInterval(interval_id);
				interval_id = null;

				if (callback) {
					interval_id = setInterval(function () {
						const hash = document.location.hash,
							re = /^#?\d+&/;
						if (hash !== last_hash && re.test(hash)) {
							last_hash = hash;
							callback({ data: hash.replace(re, '') });
						}
					}, 100);
				}
			}
		}
	};
})();
